import { useCallback, useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import {
  AnimatePresence,
  motion,
  useTransform,
  useViewportScroll,
} from "framer-motion";
import SliderVideos from "./SliderVideos";
import items from "./SliderVideosBig.json";
import Button from "../../elements/buttons/Button";
import { useMediaQuery } from "react-responsive";

const variantsMarquee = {
  visible: {
    opacity: 1,
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.33,
      ease: "easeInOut",
    },
  },
};

const SliderBig = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const isMobile = useMediaQuery({
    query: "(max-width: 995px)",
  });
  const isSmall = useMediaQuery({
    query: "(max-width: 480px)",
  });

  const autoplay = useRef(
    Autoplay(
      { delay: 3000, stopOnInteraction: false },
      (emblaRoot) => emblaRoot.parentElement
    )
  );

  const [viewportRef, embla] = useEmblaCarousel(
    {
      containScroll: "keepSnaps",
      align: "center",
      draggable: false,
      loop: true,
    },
    [autoplay.current]
  );

  const { ref: refMarquee, inView: isVisibleMarquee } = useInView({
    threshold: 0.22,
  });

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
  });

  useEffect(() => {
    if (isMobile) {
      embla?.reInit({ draggable: true });
    } else {
      if (isVisibleMarquee) {
        embla?.reInit({ draggable: true });
        autoplay?.current.play();
      } else {
        embla?.reInit({ draggable: false });
        autoplay?.current.stop();
      }
    }
  }, [embla, isMobile, isVisibleMarquee]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    embla.on("select", onSelect);
  }, [embla, onSelect]);

  const { scrollYProgress } = useViewportScroll();
  let newScale = useTransform(scrollYProgress, [0.3, 0.4], [1.69, 1]);
  let newPaddingTop = useTransform(scrollYProgress, [0.37, 0.4], [0, 50]);

  return (
    <section className="container-bigslider">
      <div className="background">
        <div className="circle1Slider"></div>
        <div className="background-gradient"></div>
      </div>
      <div className="BigSlider">
        <div className="wrap">
          <h2 className="titles">
            Las mejores series <br /> y películas para maratonear.
          </h2>
        </div>
        <div className="container-slider">
          <motion.div
            className="embla"
            style={
              !isMobile && {
                paddingTop: newPaddingTop,
                scale: newScale,
              }
            }
          >
            <div className="embla__viewport" ref={viewportRef}>
              <div className="embla__container">
                {items.map(
                  (
                    {
                      titulo,
                      categoria,
                      screenshot,
                      screenshotmobile,
                      link,
                      id,
                    },
                    index
                  ) => {
                    return (
                      <motion.div
                        className={`embla__slide ${
                          (index > selectedIndex ||
                            (index === 0 &&
                              selectedIndex === items.length - 1)) &&
                          (index !== items.length - 1 ||
                            (index === items.length - 1 &&
                              selectedIndex === index - 1)) &&
                          "mayor"
                        }`}
                        key={index}
                      >
                        <motion.div
                          className={`embla__slide__img ${
                            index === selectedIndex && "active"
                          }`}
                        >
                          <div className="sombra"></div>
                          <img
                            src={isSmall ? screenshotmobile : screenshot}
                            alt={titulo}
                          />
                        </motion.div>
                        <AnimatePresence>
                          {(isVisibleMarquee || isMobile) &&
                            index === selectedIndex && (
                              <>
                                <motion.div
                                  className="caption-slide"
                                  initial={{ y: 50, opacity: 0 }}
                                  animate={{ y: 0, opacity: 1 }}
                                  exit={{ y: 50, opacity: 0 }}
                                  transition={{
                                    type: "Inertia",
                                    delay: 0.15,
                                  }}
                                >
                                  <h4>
                                    {!isMobile ? (
                                      <>
                                        <span>{categoria}</span>
                                        <br />
                                        {titulo} &nbsp;
                                      </>
                                    ) : (
                                      <>
                                        {titulo}{" "}
                                        <div className="point-divider" />{" "}
                                        <span>{categoria}</span>
                                      </>
                                    )}
                                  </h4>
                                </motion.div>
                                <motion.div
                                  className="button-slide"
                                  initial={{ y: 50, opacity: 0 }}
                                  animate={{ y: 0, opacity: 1 }}
                                  exit={{ y: 50, opacity: 0 }}
                                  transition={{
                                    type: "Inertia",
                                    delay: 0.15,
                                  }}
                                >
                                  <Button
                                    copy="Ver ahora"
                                    link={link}
                                    className="button-primary button-icon-play"
                                  />
                                </motion.div>
                              </>
                            )}
                        </AnimatePresence>
                      </motion.div>
                    );
                  }
                )}
              </div>
            </div>
            <motion.div
              ref={refMarquee}
              variants={variantsMarquee}
              initial="hidden"
              animate={isVisibleMarquee ? "visible" : "hidden"}
            >
              <SliderVideos />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SliderBig;
